import { css } from "styled-components";
import {
	colors, devices, fonts,
	maxLinesStyle, bgLinearGradientStyleBySuffix
} from "../../../utils/styled";
import { cardContainerStyle } from "./style";

export const shadowCardStyle = css`
	.rel-content__card--shadow {
		${cardContainerStyle}
		border-radius: 10px;
		transition: box-shadow .25s ease-in, transform .25s ease-out;

		&:hover {
			box-shadow: lightgrey 0px 0px 15px 6px;
			transform: scale(1.01);
			.rel-content__card--shadow__body {
				.rel-content__card--shadow__body__title {
					h3 {
						color: ${colors.infiosGray};
					}
				}
			}
		}

		.rel-content__card--shadow__body {
			height: 150px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			padding: 16px;
			padding-top: 10px;
			background-color: ${colors.white};

			@media ${devices.mobile} {
				height: 180px;
			}

			.rel-content__card--shadow__body__description {
				> p {
					${maxLinesStyle(9)}
					color: ${colors.bluegray};
					font-family: ${fonts.AeonikPro};
					font-size: 19px;
					line-height: 120%;
					margin-top: 8px;
				}
			}

			.rel-content__card--shadow__body__date {
				font-size: 14px;
				font-family: ${fonts.AeonikMono};
				line-height: 120%;
				letter-spacing: 0.4px;
				margin-bottom: 4px;
				color: ${colors.bluegray};
			}

			.rel-content__card--shadow__body__title {
				h3 {
					${maxLinesStyle(3)}
					min-height: min-content;
					line-height: 110%;
					font-size: 19px;
					font-family: ${fonts.AeonikPro};
					color: ${colors.bluegray};
					transition: color 250ms;
					font-weight: normal;

					@media ${devices.tabletSmall} {
						font-size: 19px;
						line-height: 24px;
					}

					@media ${devices.mobile} {
						font-size: 19px;
						line-height: 22px;
					}
				}
			}

			.rel-content__card--shadow__body__bottom {
				display: flex;
				justify-content: space-between;
				height: 21px;

				.rel-content__card--shadow__body__bottom__tag {
					display: flex;
					align-items: center;
					gap: 10px;
					padding: 11px 10px;
					border-radius: 26px;
					line-height: 100%;
					font-size: 12px;
					letter-spacing: 0.5px;
					font-family: ${fonts.AeonikMono};
					box-sizing: border-box;
					border: 1px solid ${colors.bluegray};
					color: ${colors.bluegray};
					background-color: ${colors.white};
					transition: background-color 250ms ease-out;
					&:hover {
						background-color: ${colors.gray1};
					}
				}

				.rel-content__card--shadow__body__bottom__link {
					display: flex;
					align-items: center;
					gap: 4px;
					padding: 12px 10px;
					border-radius: 26px;
					font-size: 12px;
					font-weight: normal;
					font-family: ${fonts.AeonikMono};
					color: ${colors.bluegray};
					background-color: ${colors.lemon};
					transition: color 300ms ease;

					svg {
						transition: transform 200ms ease;
						fill: ${colors.bluegray};
						width: 7px;
						height: 7px;
					}

					&:hover {
						svg {
							transform: translateX(2px);
						}
					}
				}
			}
		}

		.rel-content__card--shadow__top {
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			position: relative;
			width: 100%;
			padding: 20px;
			height: 245px;

			${bgLinearGradientStyleBySuffix(colors.bluegray)}

			@media ${devices.mobile} {
				height: 300px;
			}

			.rel-content__card__readingtime {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				gap: 4px;
				font-size: 10px;
				font-weight: 500;
				font-family: ${fonts.AeonikMono};
				color: ${colors.white};
			}

			.rel-content__card--shadow__top__bg {
				z-index: -1;
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				object-fit: cover;
			}
		}

	}

`
